import { Component, OnInit,ViewChild } from '@angular/core';
import { CucurachaAdminService } from '../service/cucuracha.service';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ExcelService } from '../service/tableUtility.service';

@Component({
  selector: 'app-giveawaymanagement',
  templateUrl: './giveawaymanagement.component.html',
  styleUrls: ['./giveawaymanagement.component.css']
})
export class GiveawaymanagementComponent implements OnInit {

  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  displayedColumns = ['productId', 'productDetails.productName','productImage', 'accountDetails.emailAddress', 'productDetails.stockQuantity', 'productDetails.price']
dataSource: any;
  tableData: any;
  userDetails: any;
  userSessionData: any;
  myurl: string;
  productImageId: any;
  showFilter: boolean;
  searchValue: string;
  filterValueSelected: string;
  showCustomisedSearch: boolean;
  constructor(private cs: CucurachaAdminService,private excelService: ExcelService) {
    this.myurl = this.cs.endpoint;

   }
   viewImages(id:any){
    this.productImageId=id
  }
  filter() {
    this.getAllgiveAwayDetails()
    if (this.showFilter == false) {
      this.showFilter = true
      this.showCustomisedSearch = false
      this.searchValue=""
      this.filterValueSelected=""

    }
    else {
      this.showFilter = false
      this.showCustomisedSearch = false
      this.searchValue=""
      this.filterValueSelected=""

    }
  }
  applyCustomizedFilter() {
    this.showCustomisedSearch = true
    this.searchValue=""
    this.getAllgiveAwayDetails();

  }
  applyCustomizedFilterSearch(filterValue: string) {
    filterValue = filterValue.trim();
    filterValue = filterValue;

    if (filterValue != "") {
      this.cs.customizedFilterForGiveawayDetails(this.filterValueSelected, filterValue).subscribe((data) => {
        this.dataSource = new MatTableDataSource(data.result)

      })
    }
    else {
      this.getAllgiveAwayDetails()
    }
  }
  applyFilter(filterValue: string) {
    filterValue = filterValue.trim();
    filterValue = filterValue.toLowerCase();
    this.dataSource.filter = filterValue;
  }
  exportTable(){
    // TableUtil.exportToExcel("Example table",'usersManagement.xlsx');
    this.tableData = (this.dataSource.filteredData)
    this.excelService.exportAsExcelFile(this.tableData, 'GiveAway Detais');
    this.cs.exportLogAdd(this.userDetails.emailId,'GiveAway Detais').subscribe((data) => {
    })
  }
  ngOnInit(): void {
    this.getAllgiveAwayDetails();
    this.userSessionData = (JSON.parse(localStorage.getItem('user')))
 
    this.cs.getUserDataByEmailId(this.userSessionData).subscribe((data) => {
      this.userDetails = data[0]
    })
  }
  getAllgiveAwayDetails() {
    this.cs.getAllgiveAwayDetails().subscribe((data) => {
      this.dataSource = new MatTableDataSource(data.result);
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
    });
  }
}
